import React from 'react'
import { useFormContext } from 'react-hook-form'

import { acceptExtensions, IMAGE_MODULE } from '../../../../util/constant'

import DropzoneController from '../../../dropzone'

const GetCleaningForm = () => {
  const { control, watch } = useFormContext()

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label>Please, add detail photos of the clean place</label>
            <DropzoneController
              name="cleaning_images"
              maxFiles={100}
              acceptExtensions={acceptExtensions}
              control={control}
              files={watch('cleaning_images')}
              module={IMAGE_MODULE.CLEANING_COMPLETE}
              isEditImage={true}
              isAddMode={true}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default GetCleaningForm
